import { render, staticRenderFns } from "./sms-send.vue?vue&type=template&id=23d920b7&"
import script from "./sms-send.vue?vue&type=script&lang=js&"
export * from "./sms-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports